import { render, staticRenderFns } from "./save-translations.vue?vue&type=template&id=3346a55e&"
import script from "./save-translations.vue?vue&type=script&lang=js&"
export * from "./save-translations.vue?vue&type=script&lang=js&"
import style0 from "./save-translations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports